export const BIBLIOGRAPHIC_PRIORITY_SUBTASKS = ["US Patent", "US Trademark","US TM Image Download"];
export const CUSTOM_FORMS_PRIORITY_SUBTASKS = ["New", "Existing"];
